<div class="w-full flex flex-row items-center gap-4">
  <button (click)="onSubmit()"
          [disabled]="isSubmittingPhase || isLaunching"
          class="btn btn-primary flex flex-row gap-2 items-center min-w-[3rem]"
          style="border-radius: 0.5rem;padding: 0.5rem 1rem">
    <img alt="Icon" class="filter-neutral-100 h-4" src="/assets/icons/feather/save.svg">
    <span class="hidden lg:block cd-text-md truncate">Continuar</span>
  </button>

  <button (click)="launchSelectedSurveys()"
          [disabled]="isLaunchDisabled"
          class="btn btn-neutral-outline flex flex-row gap-2 items-center min-w-[3rem]"
          style="border-radius: 0.5rem;padding: 0.5rem 1rem">
    <img alt="Icon" class="filter-neutral-800-600 h-4" src="/assets/icons/feather/send.svg">
    <span class="hidden lg:block cd-text-md truncate capitalize">{{ launchButtonText }}</span>
  </button>
</div>

@if (launchError) {
  <div class="rounded-xl bg-neutral-100 border border-neutral-300 px-4 py-3 cd-text-b4 text-neutral-700">
    {{ launchError }}
  </div>
}

<div class="grid grid-cols-1 gap-4">
  <div class="rounded-2xl bg-neutral-100 p-6">
    <h3 class="mb-4 text-[1.25rem]">Reenvío de encuestas</h3>

    <core-table
      [data]="surveys"
      [expandableTemplate]="surveyInfoTmpl"
      [headers]="[
        { label: 'Encuesta', field: 'questions', customTemplate: surveyNameTmpl},
        { label: 'Nº Preguntas', field: 'questionsCount', options: {align: 'center', verticalAlign: 'middle'}},
        { label: 'Empleados asociados', field: 'employeesCount', options: {align: 'center', verticalAlign: 'middle'}},
      ]"
    />
  </div>
</div>

<div class="rounded-2xl bg-neutral-100 p-6">
  <h3 class="mb-4 text-[1.25rem]">Declaraciones</h3>
  <core-table
    [data]="declarations"
    [headers]="[
      { label: 'Declaración', customTemplate: declarationNameTmpl },
      { label: 'Tipo', customTemplate: declarationTypeTmpl, options: { verticalAlign: 'middle' }},
      { label: 'Valor', customTemplate: declarationValueTmpl, options: { verticalAlign: 'middle' }},
      { label: 'Variable', customTemplate: declarationVariableTmpl, options: { verticalAlign: 'middle' }},
      { label: 'Conceptos', customTemplate: declarationConceptsTmpl, options: { verticalAlign: 'middle' }},
      { label: '', customTemplate: declarationActionsTmpl, options: { align: 'right', verticalAlign: 'middle' }},
    ]"
  />
</div>

<ng-template #surveyNameTmpl let-item>
  <div class="flex flex-row gap-2 pt-2 pb-2 pl-2 pr-4">
    <input [name]="'survey_' + item.id"
           class="w-5 h-5 aspect-square rounded-full appearance-none border-2 border-gray-300 checked:bg-blue-600 checked:border-blue-600 cursor-pointer"
           [checked]="isSurveySelected(item.id)"
           [disabled]="isSurveyLocked(item.id)"
           (change)="toggleSurveySelection(item.id, $any($event.target).checked)"
           style="margin-top: 0.2rem"
           type="checkbox"/>
    <div class="flex flex-col">
      <div class="flex flex-row items-center gap-2">
        <span class="cd-text-b1 text-neutral-800">{{ item.name }}</span>
        @if (isSurveyLaunched(item.id)) {
          <span class="outline primary !py-0 !px-2 cd-text-b5">Lanzada</span>
        }
      </div>
      @if (item.description) {
        <span class="cd-text-b4 font-semibold text-neutral-500">{{ item.description }}</span>
      }
    </div>
  </div>
</ng-template>

<ng-template #surveyInfoTmpl let-item>
  <div class="w-full p-4 flex flex-col gap-2 border-1 rounded-lg mt-2" style="border-color: var(--color-neutral-400)">
    <core-table
      [data]="surveyQuestions(item)"
      [headers]="[
        { label: 'Pregunta', field: 'text', options: { verticalAlign: 'middle' }},
        { label: 'Tipo', customTemplate: surveyQuestionTypeTmpl, options: { verticalAlign: 'middle' }},
        { label: 'Variables asociadas', customTemplate: surveyVariableTmpl, options: { verticalAlign: 'middle' }},
        { label: 'Conceptos asociados', customTemplate: surveyConceptTmpl, options: { verticalAlign: 'middle' }},
      ]"
    />
  </div>
</ng-template>

<ng-template #surveyQuestionTypeTmpl let-item>
  <div class="outline primary truncate !py-0 !px-2 cd-text-b4 inline-flex max-w-full my-3">
    <span class="truncate">{{ questionTypeLabel(item) }}</span>
  </div>
</ng-template>

<ng-template #surveyVariableTmpl let-item>
  @if (questionVariableLabels(item).length) {
    <div class="w-full flex flex-wrap gap-2 my-3">
      @for (label of questionVariableLabels(item); track label) {
        <div class="outline warning truncate !py-0 !px-2 cd-text-b4 flex flex-row gap-2 max-w-full">
          <img alt="Icon" class="filter-yellow-400 h-4 shrink-0" src="/assets/icons/feather/bookmark.svg">
          <span class="truncate">{{ label }}</span>
        </div>
      }
    </div>
  } @else {
    <div class="outline warning truncate !py-0 !px-2 cd-text-b4 inline-flex flex-row gap-2 my-3 w-fit max-w-full">
      <img alt="Icon" class="filter-yellow-400 h-4 shrink-0" src="/assets/icons/feather/bookmark.svg">
      <span class="truncate">Sin variable</span>
    </div>
  }
</ng-template>

<ng-template #surveyConceptTmpl let-item>
  @if (questionConceptLabels(item).length) {
    <div class="w-full flex flex-wrap gap-2 my-3">
      @for (label of questionConceptLabels(item); track label) {
        <div class="outline secondary truncate !py-0 !px-2 cd-text-b4 flex flex-row gap-2 max-w-full">
          <img alt="Icon" class="filter-secondary-600 h-4 shrink-0" src="/assets/icons/feather/shield.svg">
          <span class="truncate">{{ label }}</span>
        </div>
      }
    </div>
  } @else {
    <div class="outline secondary truncate !py-0 !px-2 cd-text-b4 inline-flex flex-row gap-2 my-3 w-fit max-w-full">
      <img alt="Icon" class="filter-secondary-600 h-4 shrink-0" src="/assets/icons/feather/shield.svg">
      <span class="truncate">Sin concepto</span>
    </div>
  }
</ng-template>

<ng-template #declarationNameTmpl let-item>
  <div class="flex flex-col gap-1 py-1 pl-2 pr-4">
    <span class="cd-text-b2 text-neutral-900">{{ item.name }}</span>
    <span class="cd-text-b4 text-neutral-600">{{ item.description || 'Sin descripción' }}</span>
  </div>
</ng-template>

<ng-template #declarationTypeTmpl let-item>
  <span class="outline primary !py-0 !px-2 cd-text-b5 w-fit">{{ typeLabel(item) }}</span>
</ng-template>

<ng-template #declarationValueTmpl let-item>
  <span class="cd-text-b2 text-neutral-900">{{ valueLabel(item) }}</span>
</ng-template>

<ng-template #declarationVariableTmpl let-item>
  @if (item.variableName) {
    <span class="outline primary !py-0 !px-2 cd-text-b5 w-fit">{{ item.variableName }}</span>
  } @else {
    <span class="cd-text-b2 text-neutral-900">Sin variable</span>
  }
</ng-template>

<ng-template #declarationConceptsTmpl let-item>
  <div class="flex flex-wrap gap-1">
    @if (item.conceptNames?.length) {
      @for (name of item.conceptNames; track name) {
        <span class="outline secondary !py-0 !px-2 cd-text-b5">{{ name }}</span>
      }
    } @else {
      <span class="cd-text-b2 text-neutral-900">Sin conceptos</span>
    }
  </div>
</ng-template>

<ng-template #declarationActionsTmpl let-item>
  <div class="flex flex-row gap-2 justify-end">
    <button
      (click)="openEditDeclaration(item)"
      class="btn btn-primary-soft !px-2 !py-1 !w-8 !h-8 shrink-0"
      title="Editar declaración"
      type="button">
      <img alt="Editar" class="h-4 w-4 shrink-0" src="/assets/icons/feather/edit-2.svg">
    </button>
  </div>
</ng-template>
